import { SVGComponentPropsType } from 'assets/types';
import colors from 'styles/colors';

const defaultSize = 12;

const ReopenedStatusIcon = ({
  size = defaultSize,
  color = colors.agreementStatusOpen,
  ...props
}: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <circle
      cx="15"
      cy="12"
      r="5"
      transform="translate(-9 -6)"
      stroke={color}
      strokeWidth="2"
      fill="none"
      fillRule="evenodd"
    />
  </svg>
);

export default ReopenedStatusIcon;
